var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0_1164_2534)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1164_2534",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1164_2534",
    transform: "scale(0.0416667)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1164_2534",
    width: 24,
    height: 24,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAA2UlEQVR4nN2VwQ3CIBSGe3KDJi7hANaDFjx0gd4KtcNodSiX8OAErWv8BlNMFUr1gYn6J5xe+D4gwIuivwnyfALBD5DsAslBGoK1kKxWLFMg+J4MloZoZxEouyryOfkUijTROzGLnZ0KH+U8F949lujrBK6gymIIdvqIAH14TxJEgIeVszPK5TSYABa4bR5JgAF4EAEccG/BGNxL8ApcxeehHe9XscpiY4K3YLOe3SQOuJeAGgwK9HddpAkZXq4W3ZffWMysDtdw+NbeMpVE74QGbhTc2jJ/NlfKxky25yp2OQAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinking);
export default __webpack_public_path__ + "static/media/Linking.b0762f1b4678e09c3a4407e6839db507.svg";
export { ForwardRef as ReactComponent };